import { Component, OnInit } from '@angular/core';
import { ToastService } from 'angular-toastify';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-artifacts',
  templateUrl: './artifacts.component.html',
  styleUrls: ['./artifacts.component.scss']
})
export class ArtifactsComponent implements OnInit {
  packs:any = environment.pack;
  public packs$: Observable<any>|undefined;
  public upgrade$: Observable<any>|undefined;
  public myInventory$: Observable<any>|undefined;
  public loading$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  private destroy$ = new Subject();
  selected:any=null;
  user:any=null;
  showUpgrade:boolean=false;
  showUpgradeVideo:boolean=false;
  allowVid:boolean=false;
  allowImg:boolean=false;
  pack:any= environment.pack;
  artifacts:any[]=[];
  constructor(private mainfacade:MainFacade, private toast:ToastService)   { }

  ngOnInit(): void {
    this.setSub();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setSub(){
    this.packs$ = this.mainfacade.packs$;
    this.upgrade$ = this.mainfacade.upgrade$;
    this.myInventory$ = this.mainfacade.myInventory$;
    this.loading$ = this.mainfacade.loading$;
    this.user$ = this.mainfacade.user$;
    this.myInventory$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){

        this.artifacts = message.filter((item)=>{
          return item.ItemTypeId == 5;
        });
     

      }
    });

    this.upgrade$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.startUpgradeVid();
      }
      
    });

    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.user = message;
      }
      
    });
  }

  upgrade(){
    if(!this.selected){
      this.toast.error('Please select an NFT to upgrade.');
      return;
    }
    this.mainfacade.setLoading(true);
    this.mainfacade.upgradeNFT(this.user.Id, this.selected.token_id,this.user.Wallet)
    this.showUpgrade=false;
  }

  closeUpgrade(){
    this.showUpgradeVideo=false;
    this.mainfacade.closeUpgrade();
  }

  async startUpgradeVid(){
    
    this.allowVid=true;
    this.allowImg=false;
    this.showUpgradeVideo = true;
    await this.startTimer(1);
    let packvid = document.getElementById('packvid') as HTMLVideoElement;
    packvid.classList.remove('hidepack');
    this.allowImg=true;
    await this.startTimer(4.5);
    packvid.classList.add('hidepack');
    await this.startTimer(4);
    this.allowVid=false;
  }

  async startTimer(seconds:number){
    let mili = seconds * 1000;
    if(mili > 0){
      await this.delay(mili);
    }
    
  }

  delay(t) {
    return new Promise(resolve => setTimeout(resolve, t))
  }

  

}
